import { API_URL } from "../utils/config";

async function getDistributori(lat, lng) {
    try {
        const response = await fetch(API_URL + 'distributoriVicini?lat=' + lat + '&lon=' + lng);
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
}

export default getDistributori;